import { Task } from "./Task";

enum Target {
  A = 'A',
  B = 'B',
  AB = 'AB',
}

export class Battery {
  id?: string;
  name: string;
  description: string;
  code: string;
  icon: string;
  tasks: Task[];
  checked?: boolean;
  target: Target;

  constructor() {
    this.name = "";
    this.description = "";
    this.code = "";
    this.icon = "";
    this.target = Target.A
    this.tasks = []
    this.checked = false;
  }
}



export interface BatteryUploadDTO {
  targets: string[];
  items: any[];
}

export interface ImportableBattery {
  checked: boolean;
  type: string;
  object: { id: number, name: string }
}

export interface BatteryImportDTO {
  type: "batteries",
  ids: String[];
}